export default __webpack_public_path__ + "static/Education Agent Application-2f449469937d75d38bf924905bf3f588.pdf";